var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpOutlineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_829)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 10.0001,
    cy: 9.99935,
    r: 8.33333,
    stroke: "#121212",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 7.39648C8.4375 6.53354 9.13706 5.83398 10 5.83398C10.8629 5.83398 11.5625 6.53354 11.5625 7.39648C11.5625 7.96936 11.2542 8.47022 10.7945 8.74221C10.3984 8.97657 10 9.33208 10 9.79232V10.834",
    stroke: "#121212",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0001,
    cy: 13.3333,
    rx: 0.833333,
    ry: 0.833333,
    fill: "#121212",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpOutlineIcon);
export default __webpack_public_path__ + "static/media/help-outline-icon.91154045e0b0cc69e7d35eb1c82f213c.svg";
export { ForwardRef as ReactComponent };